import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from 'src/app/shared/components/header/header.module';
import { WindowShopManagerNutritionTableModule } from 'src/app/shared/components/window-shop-manager-nutrition-table/window-shop-manager-nutrition-table.module';
import { PriceTableModule } from 'src/app/shared/components/price-table/price-table.module';
import { CarouselSwiperModule } from 'src/app/shared/components/carousel-swiper/carousel-swiper.module';
import { ProductConsultaModule } from 'src/app/shared/components/product-consulta/product-consulta.module';
import { WindowShopManagerHeaderModule } from 'src/app/shared/components/window-shop-manager-header/window-shop-manager-header.module';
import { PaymentMethodsModule } from 'src/app/shared/components/payment-methods/payment-methods.module';
import { MatDividerModule } from '@angular/material/divider';
import { AssinaturaShopWindowComponent } from './assinatura-shop-window.component';
import { ProductAssinaturaModule } from "../../../shared/components/product-assinatura/product-assinatura.module";



@NgModule({
  declarations: [
    AssinaturaShopWindowComponent
  ],
  imports: [
    CommonModule,
    WindowShopManagerHeaderModule,
    WindowShopManagerNutritionTableModule,
    PriceTableModule,
    CarouselSwiperModule,
    ProductConsultaModule,
    
    PaymentMethodsModule,
    MatDividerModule,
    ProductAssinaturaModule
],
  exports:[
    AssinaturaShopWindowComponent
  ]
})
export class AssinaturaShopWindowModule { }
